import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { DealerLocationDMSICarConfig } from "models";
import type { AddEditLocationFormPayload } from "modules/DMSv3/Settings/components";

export type ICarConfig = Pick<DealerLocationDMSICarConfig, "dms_dealer_id">;

type ICarConfigSectionProps = {
  index: number;
};

const FormHelper = createFormHelper<AddEditLocationFormPayload>();

export const ICarConfigSection = ({ index }: ICarConfigSectionProps) => {
  const { t } = useTranslation();

  return (
    <Grid columns="equal">
      <GridColumn>
        <Form.Field>
          <label>{t("v8_dms_dealer_id", "DMS Dealer ID")} </label>
          <FormHelper.Field.ArrayInput fieldArrayName="dealer_location_dms" fieldKey="icar_config.dms_dealer_id" index={index} inputProps={{ fluid: true }} />
        </Form.Field>
      </GridColumn>
    </Grid>
  );
};
